// extracted by mini-css-extract-plugin
module.exports = {"container":"Jq4YErys","styledTitle":"M6QDQvI8","insightTopWrapper":"GIJyOT4Z","deepDiveWrapper":"YR41boKw","valueInfo":"aC4C40pu"};